// extracted by mini-css-extract-plugin
export default {"openForm":"UbPerpeptual_openForm__h12KK"};